import type { IconSvgObject } from './types';

const ShellIcon: IconSvgObject = [
  ["path", { d: "M11.5 12C11.0439 11.3928 10.3179 11 9.49995 11C8.11924 11 6.99995 12.1193 6.99995 13.5C6.99995 14.8807 8 17 10.5 17C13.5 17 15 14.5 15 12.5C15 9.5 12.9999 7 9.49995 7C6 7 3 9.5 3 14C3 17.3137 5.5 22 12 22C16.9706 22 21 16.9706 21 12C21 7.02944 17 2 13 2C11.8955 2 11 2.89543 11 4V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ShellIcon;
